var map = {
	"./en": "06f1",
	"./en.js": "06f1",
	"./es": "8311",
	"./es.js": "8311",
	"./zh-CN": "0a99",
	"./zh-CN.js": "0a99",
	"./zh-TW": "3f3b",
	"./zh-TW.js": "3f3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "110a";